export default {
    state: {
        channelFormData: {},
        orgChannelFormData: {},
        selectedChannelInfo: {},
        channelListData: []
    },
    mutations: {
        updateSamlFormShowHide( state, payload) {
            let selectedAuthType = []
            console.log("channel state===>", payload)
            payload.forEach(form => {
                if (form.refId == 'stageAuthType' || form.refId == 'prodAuthType') {
                    selectedAuthType = form.defaultValue
                }
                if (form.controlName == 'formGroup') {
                    if (selectedAuthType.indexOf(form.refId) >= 0) {
                        form.show = true
                    } else {
                        form.show = false
                    }
                }
            })
        } 
    },

    actions: {}
}